__turbopack_context__.v({
  "bookmarkIcon": "RQawsq_bookmarkIcon",
  "companyName": "RQawsq_companyName",
  "featuredIcon": "RQawsq_featuredIcon",
  "jobTeaserActions": "RQawsq_jobTeaserActions",
  "jobTeaserCompany": "RQawsq_jobTeaserCompany",
  "jobTeaserCompanyActive": "RQawsq_jobTeaserCompanyActive",
  "jobTeaserDate": "RQawsq_jobTeaserDate",
  "jobTeaserDateActive": "RQawsq_jobTeaserDateActive",
  "jobTeaserDescription": "RQawsq_jobTeaserDescription",
  "jobTeaserDescriptionActive": "RQawsq_jobTeaserDescriptionActive",
  "jobTeaserIcon": "RQawsq_jobTeaserIcon",
  "jobTeaserIconActive": "RQawsq_jobTeaserIconActive",
  "jobTeaserIconHideMobile": "RQawsq_jobTeaserIconHideMobile",
  "jobTeaserIconPremiumCompany": "RQawsq_jobTeaserIconPremiumCompany",
  "jobTeaserLocation": "RQawsq_jobTeaserLocation",
  "jobTeaserLocationActive": "RQawsq_jobTeaserLocationActive",
  "jobTeaserOccupation": "RQawsq_jobTeaserOccupation",
  "jobTeaserOccupationActive": "RQawsq_jobTeaserOccupationActive",
  "jobTeaserRemote": "RQawsq_jobTeaserRemote",
  "jobTeaserRemoteActive": "RQawsq_jobTeaserRemoteActive",
  "jobTeaserSalary": "RQawsq_jobTeaserSalary",
  "jobTeaserSalaryActive": "RQawsq_jobTeaserSalaryActive",
  "jobTeaserTitle": "RQawsq_jobTeaserTitle",
  "jobTeaserTitleActive": "RQawsq_jobTeaserTitleActive",
  "jobTeaserWrapper": "RQawsq_jobTeaserWrapper",
  "jobTeaserWrapperActive": "RQawsq_jobTeaserWrapperActive",
  "jobTeaserWrapperFeatured": "RQawsq_jobTeaserWrapperFeatured",
  "jobTeaserWrapperInactive": "RQawsq_jobTeaserWrapperInactive",
  "jobTeaserWrapperTopJob": "RQawsq_jobTeaserWrapperTopJob",
  "quickApplyText": "RQawsq_quickApplyText",
  "topJobIcon": "RQawsq_topJobIcon",
});
